import styled from "styled-components";
import { Row } from "../../flex/styled";

export const TopNavigationWrapper = styled(Row)(({ location }) => {
  return {
    boxSizing: "border-box",
    height: "var(--topNavHeight)",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "calc(var(--cardPadding)/4) var(--cardPadding)",
    zIndex: 1,
    "& h2": {
      marginBlock: 0,
      fontSize: "32px",
      flex: 1,

      "& h2": {
        margin: 0,
        fontSize: "32px",
      },
    },
    "& .call-to-action-buttons": {
      justifyContent: "space-between",
      gap: "1rem",
      "& span": {
        whiteSpace: "nowrap",
      },
      "& .nav-action-item": {
        position: "relative",
      },
      "& button": {
        width: "fit-content",
        borderRadius: "10px",
      },
      "& .bulk-upload-button": {
        display:
          location === "employees" || location === "departments"
            ? "inline-flex"
            : "none",
        alignItems: "center",
        padding: ".9rem 1.1rem",
        gap: ".6rem",
        backgroundColor: "var(--color-button-secondary)",
        color: "var(--color-text)",
        border: "1px solid #e5e7eb",
        "& svg": {
          flexShrink: 0,
        },
        "&:hover": {
          backgroundColor: "var(--color-button-secondary-hover)",
        },
        "@media screen and (max-width: 768px)": {
          display: "none",
        },
      },
      "& .add-employee-button": {
        display:
          location === "dashboard" ||
          location === "employees" ||
          location === "departments" ||
          location === "employer-profile" ||
          location === "payroll" ||
          location === "summary" ||
          location === "variance" ||
          location === "payroll-report" ||
          location === "general-report" ||
          location === "paye" ||
          location === "pension" ||
          location === "pricing" ||
          location === "user-summary" ||
          location === "wallet"
            ? "inline-flex"
            : "none",
        alignItems: "center",
        padding: ".9rem 1.3rem",
        gap: ".7rem",
        backgroundColor:
          location === "departments" ? "var(--color-primary)" : undefined,
        "& svg": {
          flexShrink: 0,
        },
        "&:hover": {
          backgroundColor: "var(color-primary-hover)",
        },
        "@media screen and (max-width: 768px)": {
          display: "none",
        },
      },
      "& .action-dropdown": {
        position: "absolute",
        top: "calc(100% + 10px)",
        right: 0,
        minWidth: "190px",
        margin: 0,
        padding: "0.4rem 0",
        listStyleType: "none",
        backgroundColor: "#FFFFFF",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        borderRadius: "14px",
        boxShadow: "0 16px 30px rgba(0, 0, 0, 0.14)",
        zIndex: 5,
        "& li": {
          margin: 0,
        },
        "& button": {
          width: "100%",
          background: "transparent",
          border: "none",
          padding: "0.9rem 1rem",
          textAlign: "left",
          fontFamily: "Poppins",
          fontSize: "14px",
          color: "#1A1A1A",
          cursor: "pointer",
          borderRadius: 0,
          "&:hover": {
            backgroundColor: "#F4F7FF",
            color: location === "departments" ?? "var(--color-primary)",
          },
        },
      },
      "@media screen and (max-width: 450px)": {
        flexDirection: "column",
        overflow: "hidden",
        "& .call-to-action-buttons": {
          flexWrap: "wrap",
          "& .hamburger": {
            order: -1,
          },
        },
      },
    },
    "@media screen and (min-width: 1024px)": {
      position: "absolute",
      left: "var(--sideNavWidth)",
      right: 0,
      "& .hamburger": {
        display: "none",
      },
    },
  };
});
